export default __webpack_public_path__ + "UPE.d3fb661.png";